export default __webpack_public_path__ + "ca532341da192b721266d8a9238c0ba8.png";